import type { SVGProps } from "react";
export interface BlenderIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BlenderIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BlenderIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11 18.125a1.376 1.376 0 1 1-1.368 1.516l-.007-.14.007-.141A1.375 1.375 0 0 1 11 18.125M8.18 6.875c1.362 0 2.259.3 3.044.555.741.24 1.394.445 2.455.445a7.7 7.7 0 0 0 1.798-.218 7 7 0 0 0 .644-.192l.024-.007v-.001a1.126 1.126 0 0 1 .843 2.085l-.547-1.354.126.312.42 1.044h-.002l-.008.004-.02.006-.058.024a9 9 0 0 1-.892.265 10 10 0 0 1-2.328.283c-1.423 0-2.348-.296-3.149-.556-.662-.214-1.212-.395-1.998-.436l-.352-.009c-.79 0-1.419.111-1.84.217a5 5 0 0 0-.574.179l-.016.007.003-.002.002-.001h.001l-.001-.002a1.123 1.123 0 1 1-.93-2.047l.288.63-.286-.63.002-.002.003-.001.007-.003.02-.01.06-.024a7 7 0 0 1 .873-.277 9.9 9.9 0 0 1 2.388-.284"
      />
      <path
        fill={color}
        d="M19.875 6A.876.876 0 0 0 19 5.125h-1.08l-.344 5.138 1.91-1.271a.88.88 0 0 0 .389-.728zM8.459 18.125c-.893 0-1.663.631-1.838 1.507l-.25 1.242h9.257l-.249-1.242a1.875 1.875 0 0 0-1.838-1.507zM5.976 4.44l.056.11q.074.17.09.356l.77 9.25c.08.971.894 1.719 1.869 1.719h4.433c.987 0 1.804-.766 1.87-1.75l.671-10.067a.875.875 0 0 0-.873-.933h-9.64zm16.149 3.824c0 1.044-.523 2.02-1.392 2.6l-3.108 2.072a1 1 0 0 1-.235.116l-.08 1.222a4.1 4.1 0 0 1-1.127 2.56 4.1 4.1 0 0 1 1.402 2.357l.399 1.99a1.625 1.625 0 0 1-1.594 1.944H5.61a1.625 1.625 0 0 1-1.594-1.944l.399-1.99a4.12 4.12 0 0 1 1.375-2.335 4.1 4.1 0 0 1-1.14-2.513L3.9 5.34l-.738-1.284C2.35 2.64 3.374.875 5.007.875h9.855c1.336 0 2.463.836 2.914 2H19c1.726 0 3.125 1.4 3.125 3.125z"
      />
    </svg>
  );
}
